import { Resources } from '../types/Resources';

export type Milliseconds = number;

export interface CacheEntry {
  resources: Resources;
  expiration: Milliseconds;
}

export interface Persistence {
  setItem: (key: string, value: string) => void;
  getItem: (key: string) => string | null;
  removeItem: (key: string) => void;
}

export interface Cache {
  write: (locale: string, resources: Resources, cacheDuration?: Milliseconds) => void;
  read: (locale: string) => Resources | null;
}

const FOUR_HOURS: Milliseconds = 4 * 60 * 60 * 1000;
export const DEFAULT_CACHE_DURATION: Milliseconds = FOUR_HOURS;

const createKey = (packageName: string, namespace: string, locale: string) =>
  `i18n_${packageName}_${namespace}_${locale}`;

export const create = (
  persistence: Persistence,
  packageName: string,
  namespace: string,
): Cache => ({
  write: (locale: string, resources: Resources, cacheDuration = DEFAULT_CACHE_DURATION) => {
    const key = createKey(packageName, namespace, locale);

    const value: CacheEntry = {
      resources,
      expiration: Date.now() + cacheDuration,
    };

    const valueJson = JSON.stringify(value);

    persistence.setItem(key, valueJson);
  },
  read: (locale: string) => {
    const key = createKey(packageName, namespace, locale);

    const valueJson = persistence.getItem(key);

    if (!valueJson) {
      return null;
    }

    const value = JSON.parse(valueJson) as CacheEntry;

    if (value.expiration <= Date.now()) {
      persistence.removeItem(key);
      return null;
    }

    return value.resources;
  },
});
